// Must import this way instead of shorthand { MODAL_ACTIONS, MODAL_ACTION_CREATORS } because of require in unit tests
import modalActions from './modal-actions';

const ACTIONS = {
    SET_BILLING_NAME: 'SET_BILLING_NAME',
    SET_VAS_PRODUCT: 'SET_VAS_PRODUCT',
    SET_PURCHASER: 'SET_PURCHASER',

    FETCH_CES_DATA_SUCCESS: 'FETCH_CES_DATA_SUCCESS',
    FETCH_CES_DATA_ERROR: 'FETCH_CES_DATA_ERROR',

    FETCH_AOE_DATA_SUCCESS: 'FETCH_AOE_DATA_SUCCESS',
    FETCH_AOE_DATA_ERROR: 'FETCH_AOE_DATA_ERROR',

    TRIGGER_EDAP_PAGEVIEW: 'TRIGGER_EDAP_PAGEVIEW',
    TRIGGER_EDAP_EVENT: 'TRIGGER_EDAP_EVENT',
    TRIGGER_GLOBAL_ERROR: 'TRIGGER_GLOBAL_ERROR',
    TRIGGER_PROPERTY_UNAVAILABLE_ERROR: 'TRIGGER_PROPERTY_UNAVAILABLE_ERROR',

    SET_VAS_MODAL_FORM_SELECTION: 'SET_VAS_MODAL_FORM_SELECTION',
    SET_VAS_MODAL_FORM_SUBMITTED: 'SET_VAS_MODAL_FORM_SUBMITTED',
    SET_VAS_MODAL_PAGE_NUMBER: 'SET_VAS_MODAL_PAGE_NUMBER',
    SET_VAS_AMOUNT: 'SET_VAS_AMOUNT',
    SET_VAS_STANDALONE_INTERSTITIAL: 'SET_VAS_STANDALONE_INTERSTITIAL',
    SET_LOYALTY_BURN: 'SET_LOYALTY_BURN',
    SET_MEDIA: 'SET_MEDIA',
};

const ACTION_CREATORS = {
    setCheckoutDataSuccess(response) {
        return {
            type: ACTIONS.FETCH_CES_DATA_SUCCESS,
            payload: {
                response,
            },
        };
    },
    setCheckoutDataError(response) {
        return {
            type: ACTIONS.FETCH_CES_DATA_ERROR,
            payload: {
                response,
            },
        };
    },
    setCheckoutAoeDataSuccess(response) {
        return {
            type: ACTIONS.FETCH_AOE_DATA_SUCCESS,
            payload: {
                response,
            },
        };
    },
    setCheckoutAoeDataError(response) {
        return {
            type: ACTIONS.FETCH_AOE_DATA_ERROR,
            payload: {
                response,
            },
        };
    },
    setBillingName(prop, name) {
        return {
            type: ACTIONS.SET_BILLING_NAME,
            prop,
            name,
        };
    },
    setVasProduct(sku) {
        return {
            type: ACTIONS.SET_VAS_PRODUCT,
            sku,
        };
    },
    setPurchaser(prop, name) {
        return {
            type: ACTIONS.SET_PURCHASER,
            prop,
            name,
        };
    },
    triggerEdapPageView() {
        return {
            type: ACTIONS.TRIGGER_EDAP_PAGEVIEW,
        };
    },
    triggerEdapEvent(eventName, eventData, options) {
        return {
            type: ACTIONS.TRIGGER_EDAP_EVENT,
            payload: {
                eventName,
                eventData,
                options,
            },
        };
    },
    triggerGlobalError(globalError) {
        return {
            type: ACTIONS.TRIGGER_GLOBAL_ERROR,
            globalError,
        };
    },
    triggerPropertyUnavailableError(propertyUnavailableError) {
        return {
            type: ACTIONS.TRIGGER_PROPERTY_UNAVAILABLE_ERROR,
            propertyUnavailableError,
        };
    },
    setLoyaltyBurn(loyaltyBurnSelected) {
        return {
            type: ACTIONS.SET_LOYALTY_BURN,
            payload: {
                loyaltyBurnSelected,
            },
        };
    },
    setMedia(media) {
        return {
            type: ACTIONS.SET_MEDIA,
            payload: {
                media,
            },
        };
    },
    setVasStandaloneInterstitial(isHybridVasInterstitial) {
        return {
            type: ACTIONS.SET_VAS_STANDALONE_INTERSTITIAL,
            payload: {
                isHybridVasInterstitial,
            },
        };
    },
    setVasAmount(vas) {
        return {
            type: ACTIONS.SET_VAS_AMOUNT,
            payload: {
                vas,
            },
        };
    },
};

export default {
    ...ACTIONS,
    ...modalActions.MODAL_ACTIONS,
    ...ACTION_CREATORS,
    ...modalActions.MODAL_ACTION_CREATORS,
};
